class PromiseStatus{
    static INITIALIZED = "INITIALIZED";
    static LOADING = "LOADING";
    static SUCCESS = "SUCCESS";
    static ERROR = "ERROR";
}

export default PromiseStatus;